const fontNameMap: { [family: string]: string } = {
  '001Shirokuma': 'しろくまフォント',
  '07TetsubinGothic': '鉄瓶ゴシック',
  '851CHIKARA-DZUYOKU-KANA-B': '851 チカラヅヨク',
  '851Gkktt': '851 ゴチカクット',
  '851MkPOP': '851 マカポップ',
  AoyagiKouzanFontT: '青柳衡山フォントT',
  Aoyagireisyosimo2: '青柳隷書しも',
  AsobiMemogaki: '遊びメモ書き',
  Bakudai: '莫大毛筆字體',
  BoutiqueBitmap7x7: '精品點陣體7×7',
  'Chiron Sans HK Pro': '昭源黑體',
  'Chogokuboso Gothic': '超極細ゴシック',
  'Corporate Logo Rounded ver2': 'コーポレート・ロゴ',
  DartsFont: 'ダーツフォント',
  'Dela Gothic One': 'デラゴシック',
  DotGothic16: 'ドットゴシック 16',
  'GenEi Gothic M': '源暎ゴシックM',
  'Gen Jyuu Gothic': '源柔ゴシック',
  Genkaimincho: '源界明朝',
  'GenRyuMin JP': '源流明朝',
  'GenRyuMin TW': '源流明體',
  'GenSekiGothic JP': '源石ゴシック',
  'GenSekiGothic TW': '源石黑體',
  'GenSenRounded JP': '源泉丸ゴシック',
  'GenSenRounded TW': '源泉圓體 ',
  'Gen Shin Gothic': '源真ゴシック',
  'Gen Shin Gothic Monospace': '源真ゴシック等幅',
  'Gen Shin Gothic P': '源真ゴシック P',
  'GenWanMin JP': '源雲明朝',
  'GenWanMin TW': '源雲明體',
  'GenYoGothic JP': '源様ゴシック',
  'GenYoGothic TW': '源様黑體',
  'Glow Sans J': 'ヒカリ角ゴ',
  'Glow Sans SC': '未来荧黑',
  'Glow Sans TC': '未来熒黑',
  'hachi maru pop': 'はちまるポップ',
  HanaMinPlus: '花園明朝',
  'Huayuan Gothic': '樺源黑體',
  'Huiwen-mincho': '匯文明朝',
  'I.Ming': '一點明',
  IPAexMincho: 'IPA 明朝',
  irohamaru: 'いろはマル',
  Isego: '異世ゴ',
  isemin: '異世明',
  'jf-openhuninn-1.1': 'jf open 粉圓',
  Kaisotai: '廻想体',
  kawaiitegakimoji: 'KAWAII 手書き文字',
  'Kiwi Maru': 'キウイ丸',
  'Klee One': 'クレー One',
  'Koku Mincho Regular': '刻明朝',
  'Liu Jian Mao Cao': '流江毛草',
  'long cang': '龙藏体',
  makinas: 'マキナス',
  mamelon: 'マメロン',
  'Ma Shan Zheng': '马善政毛笔楷书',
  'mukasi mukasi': '昔々ふぉんと',
  Mushin: '無心',
  'Nagurigaki Crayon': '殴り書きクレヨン',
  NaikaiFont: '內海字體',
  'New Tegomin': 'ニューテゴミン',
  'Noto Sans HK': '思源黑體 HK',
  'Noto Sans JP': '源ノ角ゴシックJP',
  'Noto Sans KR': '본고딕 KR',
  'Noto Sans SC': '思源黑体 SC',
  'Noto Sans TC': '思源黑體 TC',
  'Noto Serif JP': '源ノ明朝 JP',
  'Noto Serif KR': '본명조 KR',
  'Noto Serif SC': '思源宋体 SC',
  'Noto Serif TC': '思源宋體 TC',
  'Oradano-mincho-GSRR': 'Oradano 明朝 GSRR',
  'Otomanopee One': 'GL-オとマのペ',
  'potta One': 'ポッタ One',
  'reggae One': 'レゲエ One',
  'rocknRoll One': 'ロックンロール One',
  'ronde-B': 'ロンド B スクエア',
  'sawarabi Gothic': 'さわらびゴシック',
  'Senobi Gothic': 'せのびゴシック',
  SetoFont: '瀨戶字型',
  ShigotoMemogaki: '仕事メモ書き',
  'Shippori Mincho': 'しっぽり明朝',
  'Shippori Mincho B1': 'しっぽり明朝 B1',
  SoukouMincho: '装甲明朝',
  STICK: 'ステッキ',
  'Swei Gothic CJK JP': '獅尾圓體 JP',
  'Swei Gothic CJK SC': '狮尾圆体 SC',
  'Swei Gothic CJK TC': '獅尾圓體 TC',
  'Taipei Sans TC Beta': '台北黑體',
  'Tanuki Permanent Marker': 'たぬき油性マジック',
  'timemachine wa': 'タイムマシンわ号',
  Togalite: 'トガリテ',
  'train One': 'トレイン One',
  'TW-MOE-Std-Kai': '楷書',
  yomogi: 'よもぎフォント',
  'Yusei Magic': '油性マジック',
  'ZCOOL kuaile': '站酷快乐体',
  'ZCOOL QingKe HuangYou': '站酷庆科黄油体',
  'ZCOOL xiaowei': '站酷小薇体',
  'Zhi Mang Xing': '钟齐志莽行书',
  內海字體JP: '內海字體',
};

export default fontNameMap;
